import listActions from 'src/modules/apiKey/list/apiKeyListActions';
import ApiKeyService from 'src/modules/apiKey/apiKeyService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'APIKEY_DESTROY';

const apiKeyDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: apiKeyDestroyActions.DESTROY_STARTED,
      });

      await ApiKeyService.destroyAll([id]);

      dispatch({
        type: apiKeyDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.apiKey.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/api-key');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: apiKeyDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: apiKeyDestroyActions.DESTROY_ALL_STARTED,
      });

      await ApiKeyService.destroyAll(ids);

      dispatch({
        type: apiKeyDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.apiKey.destroyAll.success'),
      );

      getHistory().push('/api-key');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: apiKeyDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default apiKeyDestroyActions;
